import { adminWorkspaceQueryKeys as e } from "./adminWorkspaceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspaceAdminApi as r } from "@maat/api-main";
//#region src/workspaces/admin/useSetWorkspaceSuspensionMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, suspend: t, reason: n }) => r.setSuspension(e, {
			suspend: t,
			reason: n
		}),
		onSuccess: (t, { id: n }) => {
			i.invalidateQueries({ queryKey: e.detail(n) }), i.invalidateQueries({ queryKey: ["admin-workspaces", "list"] });
		}
	});
};
//#endregion
export { i as useSetWorkspaceSuspensionMutation };
